import React from 'react';

import { Icon, Text } from '@betterment/samba-react';
import { Box, Flex } from '@betterment/style-closet-react';
import styled from '@emotion/styled';

import { GoalIcon } from '../../components-v2/goal-icon/GoalIcon';

import { GoalImage, GoalImageProps, RoundedEdgeImage } from './index';

export interface GoalImageIconPairProps {
  name: Exclude<GoalImageProps['name'], 'custom'>;
}

const GoalImageContainer = styled(Flex)`
  position: relative;
  width: 112px;
  height: 112px;
  justify-content: center;
`;

const RoundedIconContainer = styled(Flex)`
  border-radius: 0.8rem;
  filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.25));
`;

const RoundedEdgeImageWithShadow = styled(RoundedEdgeImage)`
  filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.25));
`;

export const UploadImageIconPair: React.FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <GoalImageContainer borderRadius="0.8rem" backgroundColor="bmtBlue10">
      <Text
        color="text.info"
        css={{
          fontWeight: 'normal',
          marginY: 'auto',
        }}
      >
        Upload photo
      </Text>
      <Box display="flex" position="absolute" bottom="-15%">
        <Box as="span" width="3.6rem" minWidth="3.6rem" maxWidth="3.6rem" height="3.6rem">
          <RoundedIconContainer
            backgroundColor="bmtGrey10"
            width="100%"
            height="100%"
            alignItems="center"
            justifyContent="center"
          >
            <Icon name="Camera" size="small" color="icon.info" />
          </RoundedIconContainer>
        </Box>
      </Box>
    </GoalImageContainer>
  );
};

export const CustomImageIconPair: React.FC<React.PropsWithChildren<{ file: string }>> = ({ file }) => (
  <GoalImageContainer borderRadius="0.8rem">
    <RoundedEdgeImage src={file} alt="Custom uploaded image" />
    <Box display="flex" position="absolute" bottom="-15%">
      <Box as="span" width="3.6rem" minWidth="3.6rem" maxWidth="3.6rem" height="3.6rem">
        <RoundedEdgeImageWithShadow src={file} width="100%" height="100%" />
      </Box>
    </Box>
  </GoalImageContainer>
);

const GoalImageIconPair: React.FC<React.PropsWithChildren<GoalImageIconPairProps>> = ({ name }) => {
  return (
    <GoalImageContainer>
      <GoalImage name={name as GoalImageProps['name']} rounded={true} size="112px" />
      <Box display="flex" position="absolute" bottom="-15%">
        <RoundedIconContainer>
          <GoalIcon name={name} />
        </RoundedIconContainer>
      </Box>
    </GoalImageContainer>
  );
};
export default GoalImageIconPair;
